import { subscribe } from 'valtio';
import { miscUiState } from './globalState';
let toCleanup = [];
export const watchUnloadForCleanup = (func) => {
    toCleanup.push(func);
};
subscribe(miscUiState, () => {
    if (!miscUiState.gameLoaded) {
        for (const func of toCleanup) {
            func();
        }
        toCleanup = [];
    }
});
